import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import APIKeys from "./APIKeys";
import { useFeatureFlag } from "../utils/featureFlags";
import VendorBatchIntegration from "./VendorBatchIntegration";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "zapier-workflow": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        "client-id"?: string;
        theme?: string;
        "intro-copy-display"?: string;
        "guess-zap-display"?: string;
        "app-selection-display"?: string;
        "template-ids"?: string;
        "zap-create-from-scratch-display"?: string;
      };
    }
  }
}

const Integration: React.FC = () => {
  const isZapierEnabled = useFeatureFlag('enableZapierIntegration');

  useEffect(() => {
    // Only load Zapier scripts if the feature is enabled
    if (!isZapierEnabled) {
      return;
    }

    // Load the Zapier script
    const script = document.createElement("script");
    script.type = "module";
    script.src =
      "https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js";
    script.async = true;
    document.head.appendChild(script);

    // Load the Zapier stylesheet
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css";
    document.head.appendChild(link);

    // Cleanup function to remove the script and link when the component unmounts
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(link);
    };
  }, [isZapierEnabled]);

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <Paper elevation={3} style={{ borderRadius: 3,border: "1px solid #444", height: "325" }}>
              <Box
                m={2}
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <APIKeys />
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Paper elevation={3} style={{ borderRadius: 2, height: "325" }}>
              <Box m={2}>
                <Typography variant="h5" m={2}>
                  API Documentation
                </Typography>
                <Typography variant="body2">
                  The API documentation provides detailed information on how to
                  use the API. It includes the API endpoints, request and
                  response examples, and the necessary headers.
                  <br />
                  <br />
                </Typography>
                <Button
                  sx={{ margin: 2 }}
                  variant="contained"
                  color="primary"
                  href="https://documenter.getpostman.com/view/28610834/2sAYX5KNAf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Documentation
                </Button>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <VendorBatchIntegration />
          </Grid>
          {isZapierEnabled && (
            <Grid item xs={12}>
              <Box m={2}>
                <zapier-workflow
                  client-id="SM1gIUdv9jj31WDZ8P88xPbsjNgzYNtfmQmlHck7"
                  theme="dark"
                  intro-copy-display="hide"
                  guess-zap-display="hide"
                  app-selection-display="hide"
                  template-ids="1550277,255606500"
                  zap-create-from-scratch-display="hide"
                ></zapier-workflow>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default Integration;
